import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { LanguageProvider } from './context/LanguageProvider';
import { CookieProvider } from './context/CookieContext';

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <BrowserRouter>
    <LanguageProvider>
      <CookieProvider>
        <>
          <App />
        </>
      </CookieProvider>
    </LanguageProvider>
  </BrowserRouter>
);